import { render } from "./VideoTutorials.vue?vue&type=template&id=43443578&scoped=true"
import script from "./VideoTutorials.vue?vue&type=script&lang=js"
export * from "./VideoTutorials.vue?vue&type=script&lang=js"

import "./VideoTutorials.vue?vue&type=style&index=0&id=43443578&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43443578"]])

export default __exports__